export default __webpack_public_path__ + "static/caramel-choc-flake-5f8cab3b9a6537442915c64bc0bbf844.png";